import client from "./axiosConfig";

/* ============================
   COURSES
============================ */

/** List courses (HR: all, others: active only) */
export const getAllCourses = (params) => {
  return client({
    url: "/training/courses/",
    method: "GET",
    params,
  });
};

/** Get single course (for edit mode) */
export const getCourseById = (courseId) => {
  return client({
    url: `/training/courses/${courseId}/`,
    method: "GET",
  });
};

/** Create course */
export const createCourse = (formData) => {
  return client({
    url: "/training/courses/",
    method: "POST",
    data: formData,
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
};

/** Update course (EDIT MODE) */
export const updateCourse = (courseId, formData) => {
  return client({
    url: `/training/courses/${courseId}/`,
    method: "PATCH",
    data: formData,
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
};

/** Delete course */
export const deleteCourse = (courseId) => {
  return client({
    url: `/training/courses/${courseId}/`,
    method: "DELETE",
  });
};

/* ============================
   MODULES (NESTED)
============================ */

/** Create module under course */
export const createModule = (courseId, formData) => {
  return client({
    url: `/training/courses/${courseId}/modules/`,
    method: "POST",
    data: formData,
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
};

/** Update course (EDIT MODE) */
export const updateModule = (courseId, moduleId, formData) => {
  return client({
    url: `/training/courses/${courseId}/modules/${moduleId}/`,
    method: "PATCH",
    data: formData,
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
};

/** Delete module under course */
export const deleteModule = (courseId, moduleId) => {
  return client({
    url: `/training/courses/${courseId}/modules/${moduleId}/`,
    method: "DELETE",
  });
};

/** Get module under course */
export const getModule = (courseId, moduleId) => {
  return client({
    url: `/training/courses/${courseId}/modules/${moduleId}/`,
    method: "GET",
  });
};

/** Mark as complete to module under course */
export const markAsCompleteModule = (courseId, moduleId,body) => {
  return client({
    url: `/training/courses/${courseId}/modules/${moduleId}/complete/`,
    method: "POST",
    data:body
  });
};

/** Get user-wise course progress for HR */
export const getUserWiseCourseProgress = (params) => {
  return client({
    url: "/training/user-course-progress/",
    method: "GET",
    params,
  });
};
